// src/services/billingService.js
/**
 * Servicio para integrar el flujo de App Billing de Tiendanube.
 * Asume que el backend (Cloud Functions / API propia) expone los endpoints
 *   POST /billing/initiate  → body: { plan }
 *     → { redirectUrl }
 *   GET  /billing/status    → devuelve { plan: 'free' | 'pro' | 'trial', nextChargeDate }
 *
 * El frontend solamente redirige al merchant a la URL devuelta por `initiateBilling`.
 */
import apiClient from './apiClient';

export async function initiateBilling(plan) {
  if (!plan) throw new Error('Plan requerido');
  const { data } = await apiClient.post('/api/billing/initiate', { plan });
  return data; // { redirectUrl }
}

export async function fetchPlanStatus() {
  const { data } = await apiClient.get('/api/billing/status');
  return data; // { plan, nextChargeDate }
}

/**
 * Historial de facturación del merchant.
 * Devuelve array de objetos { date, number, concept, amount, status, invoiceUrl }
 */
export async function fetchBillingHistory() {
  try {
    const { data } = await apiClient.get('/api/billing/history');
    return data?.history || [];
  } catch (e) {
    console.warn('[billingService] usando historial mock:', e.message);
    return [
      { date: '15/05/2025', number: 'FAC-2025-0001', concept: 'Plan Profesional - Mayo 2025', amount: 79, status: 'Pagada', invoiceUrl: '#' },
      { date: '15/04/2025', number: 'FAC-2025-0002', concept: 'Plan Profesional - Abril 2025', amount: 79, status: 'Pagada', invoiceUrl: '#' },
    ];
  }
}
